import type { FC, PropsWithChildren } from "react";
import type { UserType } from "@/types/graphql/partner";
import { AuthContext } from "./AuthContext";
import { AbilityProvider } from "./AbilityProvider";

export interface AuthProviderProps extends PropsWithChildren {
  user: UserType;
}

export const AuthProvider: FC<AuthProviderProps> = ({ user, children }) => {
  return (
    <AuthContext.Provider value={{ user }}>
      <AbilityProvider user={user}>{children}</AbilityProvider>
    </AuthContext.Provider>
  );
};
